<div style="padding-top: 10px">
  <form novalidate [formGroup]="flowlineForm">
    <div class="flex-row flex-align-start flex-auto">
      <!-- Left Column -->

      <!-- Right Column -->
      <div class="flex-column flex-100">
        <!-- <h6 class="card-title">
        Pipe Lay Planning Details
      </h6> -->
        <div style="padding-left: 10px">
          <div class="flex-row">
            <div class="flex-20">
              <label class="formation-tops-title"></label>
            </div>
            <div class="flex-20">
              <label class="formation-tops-title">Flowline 1</label>
            </div>
            <div class="flex-20">
              <label class="formation-tops-title">Flowline 2</label>
            </div>
            <div class="flex-20">
              <label class="formation-tops-title">Flowline 3</label>
            </div>
            <div class="flex-20">
              <label class="formation-tops-title">Flowline 4</label>
            </div>
            <div class="flex-20">
              <label class="formation-tops-title">Gas Lateral</label>
            </div>
            <div class="flex-20">
              <label class="formation-tops-title">Gas Trunk</label>
            </div>
          </div>
        </div>
        <div style="padding-left: 10px">
          <div class="flex-row">
            <div class="flex-20 freeze-column">
              <div class="form-group-element">
                <input
                  type="text"
                  class="k-textbox form-control"
                  value="Rock Ditching %"
                  readonly />
              </div>
            </div>
            <div class="flex-20">
              <div class="form-group-element">
                <kendo-numerictextbox
                  class="form-control"
                  [decimals]="decimalPrecision2"
                  [spinners]="false"
                  [format]="decimalFormat2"
                  formControlName="RockDitchingPercent">
                </kendo-numerictextbox>
              </div>
            </div>
          </div>
        </div>
        <div style="padding-bottom: 14px">
          <div style="padding-left: 10px">
            <div class="flex-row">
              <div class="flex-20 freeze-column">
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Total Length"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="New Ditch"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Additional Length"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Line Diameter (in)"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Line Count"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Risers"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Valve Station"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Bore Size (in)"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Bore Length (ft)"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Line Crossings"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Fence Gaps"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Gates"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Right of way ($)/ft"
                    readonly />
                </div>
                <div class="form-group-element">
                  <input
                    type="text"
                    class="k-textbox form-control"
                    value="Reseeding"
                    readonly />
                </div>
              </div>
              @for (flowlineVal of flowLineValues.controls; track flowlineVal; let i = $index) {
              <div class="flex-20" formArrayName="flowlineTypeData">
                <ng-container [formGroupName]="i">
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="TotalLength"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="NewDitch"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="AdditionalLength"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat"
                      [readonly]="true">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-dropdownlist
                      class="form-control"
                      [style.width.%]="100"
                      formControlName="LineDiameter"
                      [data]="lineDiameters"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="LineCount"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="Risers"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="ValveStation"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-dropdownlist
                      class="form-control"
                      [style.width.%]="100"
                      formControlName="BoreSize"
                      [data]="boreSizes"
                      [valuePrimitive]="true">
                    </kendo-dropdownlist>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="BoreLength"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="LineCrossings"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="FenceGaps"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="Gates"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="RightOfWay"
                      class="form-control"
                      [decimals]="decimalPrecision2"
                      [spinners]="false"
                      [format]="decimalFormat2"
                      [readonly]="i === 0">
                    </kendo-numerictextbox>
                  </div>
                  <div class="form-group-element">
                    <kendo-numerictextbox
                      formControlName="Reseeding"
                      class="form-control"
                      [decimals]="decimalPrecision"
                      [spinners]="false"
                      [format]="decimalFormat">
                    </kendo-numerictextbox>
                  </div>
                </ng-container>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-left: 10px">
      <div class="flex-row">
        <div class="flex-20 freeze-column">
          <div class="form-group-element">
            <input
              type="text"
              class="k-textbox form-control"
              value='2" SDR Box Length (ft)'
              readonly />
          </div>
        </div>

        <div class="flex-20">
          <div class="form-group-element">
            <kendo-numerictextbox
              class="form-control"
              [decimals]="decimalPrecision"
              [spinners]="false"
              [format]="decimalFormat"
              formControlName="TwoInchSDRBoxLengthFT">
            </kendo-numerictextbox>
          </div>
        </div>
      </div>
    </div>

    <div style="padding-left: 10px">
      <div class="flex-row">
        <div class="flex-20 freeze-column">
          <div class="form-group-element">
            <input
              type="text"
              class="k-textbox form-control"
              value='3" SDR Box Length (ft)'
              readonly />
          </div>
        </div>
        <div class="flex-20">
          <div class="form-group-element">
            <kendo-numerictextbox
              class="form-control"
              [decimals]="decimalPrecision"
              [spinners]="false"
              [format]="decimalFormat"
              formControlName="ThreeInchSDRBoxLengthFT">
            </kendo-numerictextbox>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>